/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PerformSetTagsMutationResponse,
  PerformSetTagsPathParams,
  PerformSetTags404,
} from '../types/PerformSetTags'

function getPerformSetTagsUrl({
  import_number,
}: {
  import_number: PerformSetTagsPathParams['import_number']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/importengine/previews/v2/${import_number}/set-tags/` as const,
  }
  return res
}

/**
 * @summary Dispatch the set-tags step for an import preview
 * {@link /api/v1/importengine/previews/v2/:import_number/set-tags/}
 */
export async function performSetTags(
  {
    import_number,
  }: { import_number: PerformSetTagsPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    PerformSetTagsMutationResponse,
    ResponseErrorConfig<PerformSetTags404>,
    unknown
  >({
    method: 'POST',
    url: getPerformSetTagsUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
